interface EditDocumentsButtonProps {
  onClick: () => void;
  label?: string;
}

const EditDocumentsButton = ({ onClick, label = 'Edit Documents' }: EditDocumentsButtonProps) => {
  return (
    <button
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.35rem',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        color: '#436EB2',
        fontSize: '0.875rem',
        fontWeight: 600,
      }}
    >
      <span>{label}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="25"
        viewBox="0 0 28 25"
        fill="none"
      >
        <path
          d="M0 7.54005H17.16V10.66H0V7.54005ZM0 4.42005H17.16V1.30005H0V4.42005ZM0 16.9H10.92V13.78H0V16.9ZM23.4156 12.0172L24.5232 10.9096C25.1316 10.3012 26.1144 10.3012 26.7228 10.9096L27.8304 12.0172C28.4388 12.6256 28.4388 13.6084 27.8304 14.2168L26.7228 15.3244L23.4156 12.0172ZM22.308 13.1248L14.04 21.3928V24.7H17.3472L25.6152 16.432L22.308 13.1248Z"
          fill="#436EB2"
        />
      </svg>
    </button>
  );
};

export default EditDocumentsButton;
